import { InAppMessageDeliverProcessor } from "../../deliver/InAppMessageDeliverProcessor"
import { InAppMessageDelayManager } from "../../delay/InAppMessageDelayManager"
import { InAppMessageScheduleRequest } from "../InAppMessageScheduleRequest"
import { InAppMessageScheduleResponse } from "../InAppMessageScheduleResponse"
import { InAppMessageDeliverRequest } from "../../deliver/InAppMessageDeliverRequest"
import { InAppMessageScheduleType } from "../InAppMessageScheduleType"
import ObjectUtil from "../../../../core/internal/util/ObjectUtil"
import { AbstractInAppMessageScheduler } from "./AbstractInAppMessageScheduler"

export class DelayedInAppMessageScheduler extends AbstractInAppMessageScheduler {
  constructor(
    private readonly deliverProcessor: InAppMessageDeliverProcessor,
    private readonly delayManager: InAppMessageDelayManager
  ) {
    super()
  }

  /**
   * @override
   */
  supports(scheduleType: InAppMessageScheduleType): boolean {
    return scheduleType === "DELAYED"
  }

  /**
   * @override
   */
  async deliver(request: InAppMessageScheduleRequest): Promise<InAppMessageScheduleResponse> {
    const delay = this.delayManager.delete(request)
    ObjectUtil.requiredNotNullOrUndefined(
      delay,
      () => `InAppMessageDelay not found (inAppMessageKey=${request.schedule.inAppMessageKey})`
    )

    const deliverRequest = InAppMessageDeliverRequest.of(request)
    const deliverResponse = await this.deliverProcessor.process(deliverRequest)
    return InAppMessageScheduleResponse.of(request, "DELIVER", deliverResponse)
  }

  /**
   * @override
   */
  async delay(request: InAppMessageScheduleRequest): Promise<InAppMessageScheduleResponse> {
    const delay = this.delayManager.delay(request)
    return InAppMessageScheduleResponse.of(request, "DELAY", null, delay)
  }

  /**
   * @override
   */
  async ignore(request: InAppMessageScheduleRequest): Promise<InAppMessageScheduleResponse> {
    const delay = this.delayManager.delete(request)
    return InAppMessageScheduleResponse.of(request, "IGNORE", null, delay)
  }
}
